<template>
    <section class="main">
        <HeadSectionMain :data="head" class="fill-height"/>
        <OurProducts style="background:  #F9F9F9"/>
        <h1 class="title" style="background:  #F9F9F9">{{ title[lang]}}</h1>
        <template v-for="(product, i) in listProducts" :key="i">
            <productComponent :data="product"
                              class="color-gray"
                              :src-img="'products/proVision/'"
                              :class="[
                                  i%2 && 'color-white',
                              ]"
            >
                <template v-slot:sensors v-if="product?.sensors">
                    <div class="sensors-wrap">
                        <h5 style="margin-bottom: 20px">{{ product.sensors.title[lang] }}</h5>
                        <ul class="sensors">
                            <li v-for="(sensor, i) in product?.sensors?.list" :key="i" class="sensors__item">
                                <div class="sensors__img">
                                    <img :src="require('@/assets/sensors/'+sensor.img)" :alt="sensor.img">
                                </div>
                                <p class="size-14-500 sensors__title">
                                    {{ sensor.name }}
                                </p>
                            </li>
                        </ul>
                        <ButtonBookDemo/>
                    </div>
                </template>
            </productComponent>
        </template>
        <ourMobileApplication />
        <infoComponent class="white-bg"/>
    </section>
</template>

<script>
export default {
    name: "visionPage",
    data() {
        return {
            jsonFile: '',
            title: {
                en: "ProVision Features",
                es: "ProVision Features",
                pt: "ProVision Features",
            }
        }
    },
    computed: {
        lang() {
            return this.$i18n.locale
        },
        head(){
            return this.jsonFile?.head
        },
        listProducts() {
            return this.jsonFile?.list_products
        },
    },
    created() {
        this.jsonFile = require('../../pages/proVision.json');
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
.main {
    .title {
        text-align: center;
        padding: 60px 0;
    }
    .product-item {
        &.color-gray {
            background: #FAFBFD;
        }
        &.color-white {
            background: white;
        }
    }
    .white-bg {
        position: relative;
        background: white;
        padding: 85px 0;
        margin-top: -250px;
    }
    .sensors-wrap {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 50px;
    }
    .sensors {
        display: grid;
        grid-template-columns: repeat(3, 100px);
        grid-auto-rows: min-content;
        gap: 20px;

        &__img {
            width: 55px;
            height: 55px;
        }

        &__item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
        }
        &__title {
            text-align: center;
        }
    }
}
@media all and (max-width: 1550px) {
    .main {
        .white-bg {
            margin-top: -15%;
        }
        .sensors-wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
}
//@media all and (max-width: 900px) {
//    .main {
//        .white-bg {
//            margin-top: -20%;
//        }
//        .sensors-wrap {
//            display: flex;
//            flex-direction: column;
//            align-items: center;
//        }
//    }
//}
</style>